import React from "react";
import { CryptoData, CryptoStats } from "@/types/Currency.tsx";
import { useQuery } from "@tanstack/react-query";
import { ApiResponse } from "@/types/Api.tsx";
import GenericApi from "@/api/genericApi.tsx";
import { CryptoDataQueryKey } from "@/config/constants/QueryKeys.tsx";

interface CryptoCardProps {
  cryptoStat: CryptoStats | null;
}

const CryptoCard: React.FC<CryptoCardProps> = ({ cryptoStat }) => {
  const textColor =
    Number(cryptoStat?.percent_change_7d) >= 0 ? "#2dde24" : "#ff0000";

  const url = `https://min-api.cryptocompare.com/data`;

  const { data: cryptoData } = useQuery<ApiResponse<CryptoData>>({
    queryFn: async () =>
      GenericApi.get<CryptoData>(
        `/pricemultifull?fsyms=${cryptoStat?.symbol}&tsyms=${cryptoStat?.symbol}`,
        url
      ),
    queryKey: [CryptoDataQueryKey, cryptoStat?.symbol],
    refetchInterval: 10000,
  });

  const getMediaLink = () => {
    if (cryptoStat?.symbol) {
      return cryptoData?.data?.RAW?.[cryptoStat?.symbol]?.[cryptoStat?.symbol]
        ?.IMAGEURL;
    }

    return null;
  };

  const mediaLink = getMediaLink();

  const flagUrls: Record<string, string> = {
    EUR: "https://flagcdn.com/w320/eu.png",
    USD: "https://flagcdn.com/w320/us.png",
    RON: "https://flagcdn.com/w320/ro.png",
    GBP: "https://flagcdn.com/w320/gb.png",
    JPY: "https://flagcdn.com/w320/jp.png",
    PLN: "https://flagcdn.com/w320/pl.png",
    AUD: "https://flagcdn.com/w320/au.png",
    CAD: "https://flagcdn.com/w320/ca.png",
    CHF: "https://flagcdn.com/w320/ch.png",
    // Adaugă aici alte monede relevante
  };

  const imageUrl =
    (cryptoStat?.symbol && flagUrls[cryptoStat.symbol]) ||
    (mediaLink
      ? `https://www.cryptocompare.com/${mediaLink}`
      : "https://via.placeholder.com/24");

  const formattedValue = Number(cryptoStat?.value)?.toFixed(4);
  const formattedPercentChange = Number(cryptoStat?.percent_change_7d)?.toFixed(
    2
  );

  return (
    <div
      className={`relative py-3 px-2 flex flex-row items-center gap-4 w-full max-w-[290px] max-h-[10rem] Container pshadow`}
    >
      <img
        className="w-12 h-12 rounded-full self-start"
        src={imageUrl}
        alt="Bitcoin"
      />

      <div className="flex flex-col">
        <p className="Subtitle dark-blue bold">{cryptoStat?.name}</p>
        <p style={{ color: textColor }} className={`Text medium`}>
          {formattedPercentChange}% this week
        </p>
        <p className="Subtitle dark-blue medium mt-5">${formattedValue}</p>
      </div>
    </div>
  );
};

export default CryptoCard;
